import BlockHeading from './BlockHeading'

export default BlockHeading
